module.exports = __webpack_public_path__ + "./favicons/apple-icon-144x144.png";